/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { ENVIRONMENT_HELPER } from "@/helpers/environment.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const USER_SERVICE = {
    login,
    logout
};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Users";

/* Services */
function login(email, password) 
{
    // Mandatory parameters
    if(!email || !password)
    {
        throw("The parameters are not complete!");
    }

    //

    var data = new URLSearchParams();
    data.append('email', email);
    data.append('password', password);

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data,
    };

    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "Login"]);

    return fetch(encodeURI(url), requestOptions)
        .then(response =>{
            return response.text().then(text => {
                const data = text && JSON.parse(text);

                if (!response.ok) {
                    return Promise.reject(data.message);
                }
                return data;
            });        
        })
        .then(data => {
            var user = data.obj;
            // login successful if there's a jwt token in the response
            if (user.userTokens && user.userTokens.accessToken) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        })
        .catch(error=> {
            var errorMsg;

            if(typeof error != 'string')
            {
                if(ENVIRONMENT_HELPER.isProd())
                {
                    errorMsg = "Something went wrong, please try again. If the problem persists contact the support.";
                }
                else
                {
                    errorMsg = error.toString();
                }
            }
            else
            {
                errorMsg = error;
            }

            return Promise.reject(errorMsg);
        });
}

function logout() {
    // TODO Integrate logout service
    return true;
}